import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import SectionHead from "./SectionHead.js";

const useStyles = makeStyles(styles);

/**
 * B-01 §28.3 item 3, condensed from §8.
 *
 * Each step carries its actor as a column of its own rather than a
 * parenthetical: who holds the next move is the part of the procedure a
 * consumer can actually check, so it earns its own lane.
 */
export default function ProcessSection({ t, num }) {
  const classes = useStyles();

  return (
    <section id="section-process" className={classes.section}>
      <SectionHead num={num} title={t.processTitle} />

      <div className={classes.steps}>
        {t.processSteps.map((s, i) => (
          <div className={classes.stepRow} key={s.step}>
            <span className={classes.stepNum}>{i + 1}</span>
            <div className={classes.stepCell}>
              <p className={classes.stepText}>{s.step}</p>
              <span className={classes.stepActor}>{s.actor}</span>
            </div>
          </div>
        ))}
      </div>

      <div className={classes.noteList}>
        {t.processNotes.map((note) => (
          <div className={classes.noteRow} key={note}>
            <span className={classes.noteDash} aria-hidden="true">
              —
            </span>
            <p className={classes.noteText}>{note}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
